import React, { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useClientAuth } from '../context/ClientAuthContext';

/**
 * Bannière in-app affichée dans les dernières 24h de l'essai gratuit (Suivi Pro /
 * Suivi Pro+) — en complément de l'email de rappel J-2 déjà existant. Se base sur
 * `trial_ending_soon` calculé côté backend (GET /api/tracking/subscription).
 */
export const TrialEndingBanner = ({ en, onManage }) => {
  const { authFetch } = useClientAuth();
  const [sub, setSub] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    authFetch('/api/tracking/subscription').then((r) => r.json()).then(setSub).catch(() => {});
  }, [authFetch]);

  if (!sub?.trial_ending_soon || dismissed) return null;
  const L = (fr, eng) => (en ? eng : fr);
  const endDate = sub.current_period_end
    ? new Date(sub.current_period_end).toLocaleString(en ? 'en-US' : 'fr-CH', { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' })
    : '';

  return (
    <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 text-black" data-testid="trial-ending-banner">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-xs sm:text-sm font-bold">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          <span>
            {L(
              `Votre essai gratuit se termine le ${endDate} — votre carte sera débitée automatiquement ensuite.`,
              `Your free trial ends on ${endDate} — your card will be charged automatically afterward.`
            )}
          </span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button onClick={onManage} className="px-3 py-1 rounded-full text-xs font-bold bg-black/85 text-white hover:bg-black transition-colors" data-testid="trial-ending-banner-manage">
            {L('Gérer mon abonnement', 'Manage subscription')}
          </button>
          <button onClick={() => setDismissed(true)} aria-label={L('Fermer', 'Close')} className="p-1 hover:opacity-70 transition-opacity" data-testid="trial-ending-banner-close">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialEndingBanner;
